import useSWR from "swr";
import { Inventory } from "types/inventory";
import { fetcher } from "services/api.service";

export const useSwrInventory = (inventoryId?: number | string) => {
  return useSWR<Inventory>(inventoryId ? `/inventories/${inventoryId}` : null, fetcher);
};
